import React from 'react';
import { FormGroup, HelpBlock, ControlLabel, FormControl } from 'react-bootstrap';

//const test_stripe_id = 'pk_test_wMXXdG7oQnV1AwDqjg1fYNlX';
const live_stripe_id = 'pk_live_9AYKkJRuGeDPOS6FBxrtzrKw';
const stripe_id = live_stripe_id;

class StripeCheckout extends React.Component {
	constructor(props) { 
		super(props);
		this.state = {
			stripe_id : stripe_id,
			form_id : props.form_id,
			cardError: ''
		};

		this.onCardTextChange = this.onCardTextChange.bind(this);
		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.submitToken = this.submitToken.bind(this);
	}

	componentWillMount() { 
		this.stripe = window.Stripe(this.state.stripe_id);
		this.elements = this.stripe.elements();
		this.card = this.elements.create('card');
	}

	submitToken(token) { 
		const inToken = document.getElementById('stripeToken');
		inToken.setAttribute('value', token.id);

		this.props.onPaymentReady(token.id);
	}

	onFormSubmit(event) {
		event.preventDefault();

		const that = this;
		this.stripe.createToken(this.card).then(function(result) {
			if(result.error) {
			  that.onCardTextChange(result);
			} else {
			  that.submitToken(result.token);
			}
		});
	}

	componentDidMount() {
		this.card.mount('#card-element');
		this.card.on('change', this.onCardTextChange);

		const form = document.getElementById(this.state.form_id);
		form.addEventListener('submit', this.onFormSubmit);
	}

	onCardTextChange(event) { 
		let cardError = '';
		if (event.error) {
			cardError = event.error.message;
		}
		this.setState( prevState => (
			{
				stripe_id : prevState.stripe_id,
				form_id : prevState.form_id,
				cardError: cardError
			}
		));
	}

	componentWillUnmount() { 
		this.card.unmount();
		this.card.on('change', null);
		const form = document.getElementById(this.state.form_id);
		form.removeEventListener('submit', this.onFormSubmit);
	}

	render() { 
		return (
				<FormGroup>
			      <ControlLabel htmlFor="card-element">Credit or Debit Card</ControlLabel>
			      <FormControl.Static className="form-control" id="card-element"></FormControl.Static>
			      <HelpBlock id="card-errors">{this.state.cardError}</HelpBlock>
			      <FormControl type="hidden" id="stripeToken" name="stripeToken"/>
			    </FormGroup>
			);
	}
}

export default StripeCheckout;


// WEBPACK FOOTER //
// ./src/StripeCheckout.js